export default __webpack_public_path__ + "static/media/home-img2.170e36e0.png";